<template>
  <kst-section>
    <template #title>
      <kst-title standard>{{ Info.Section.TransSummary.Title }}</kst-title>
    </template>

    <kst-table view-mode :data="transSummaryList">
      <b-table-column
        v-slot="{ row }"
        field="Label"
        :label="DashListCatalog.Name.Label"
      >
        {{ row.Label }}
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-hpptotal has-text-weight-bold"
        field="HppTotal"
        :label="DashListCatalog.HppTotal.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="DashListCatalog"/>
      </b-table-column>

      <b-table-column
        v-slot="{ row }"
        cell-class="ks-col-action ks-col-action-view-padding"
        field="HppTotal"
      >
        <kst-button actionMode
          :class="Info.Button.Transaction.Class"
          :hasAccess="row.HasAccess"
          :label="Info.Button.Transaction.Label"
          :module="row.Module"
          :moduleType="Info.Button.Transaction.ModuleType"
          :urlParams="getUrlParams(row.Search, row.Params)"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import RouterMixin from "../../../mixins/RouterMixin.js";
import Info from "../DashInfo.js";
import DashListCatalog from "../DashListCatalog.js";
import DashTransSearchCatalog from "../DashTransSearchCatalog.js";

export default {
  mixins: [RouterMixin],
  props: {
    transSummaryList: Array
  },
  data: () => ({
    Info: Info,
    DashListCatalog: DashListCatalog
  }),
  methods: {
    getUrlParams(search, params) {
      const urlQueryObj = this.getUrlQueryObj(
        search, params, DashTransSearchCatalog
      );
      return this.$kst.Route.getParams(urlQueryObj);
    }
  }
}
</script>